export default {
  header: {
    p1: 'Home',
    p2: 'Singapore Node',
    p3: 'My Records',
    p4: 'Referral Program',
    p5: 'FAQ',
    p6: '中文',
    p7: 'Share',
    p8: 'Connect wallet',
  },
  home: {
    p1: '21 Root Nodes',
    p2: 'Bound to 21 cities, 2000 co-builder digital identity certificates per city',
    p3: 'Start your Web3 learning journey, build Web3 talent infrastructure, empower industry Web3 upgrade',
    p4: 'Singapore',
    p5: 'Price increases 30% with each city opening',
    p6: 'Buy Now',
    p7: 'Earn Commission',
    p8: 'Built on BSC · Secure & Transparent',
    p9: 'Explore More',
  },
  node: {
    p1: 'Singapore',
    p2: 'Root Node',
    p3: 'Limited to 2,000 units. Collect Singapore digital identity certificate and become a core co-builder, join the international root node of the business school.',
    p4: 'Open',
    p5: 'Singapore',
    p6: 'per unit',
    p7: 'Minted',
    p8: 'Remaining',
    p9: 'units',
    p10: 'Payment Method',
    p11: 'Quantity',
    p12: 'Max per city 50 units',
    p13: 'Total Amount',
    p14: 'Mint Now',
    p15: 'Connect wallet',
    p16: 'Total Cities',
    p17: 'Total NFTs',
    p18: 'Per City Limit',
    p19: 'Per Person Limit',
    p20: 'Confirm Mint',
    p21: 'Please confirm the following mint information',
    p22: 'City Node',
    p23: 'Singapore',
    p24: 'Quantity',
    p25: 'units',
    p26: 'Payment Method',
    p27: 'Full USDC',
    p28: 'Total Amount',
    p29: 'Fund Allocation',
    p30: 'Cancel',
    p31: 'Confirm Mint',
    p32: 'Approving',
    p34: 'Minting',
    p35: 'By clicking confirm, you agree to our Terms of Service',
  },
  record: {
    p1: 'My Records',
    p2: 'My',
    p3: 'Records',
    p4: 'View your mint records and referral reward details',
    p5: 'Mint Records',
    p6: 'Reward Details',
    p7: 'Mint Records',
    p8: 'No.',
    p9: 'Time',
    p10: 'Invite Address',
    p11: 'Quantity',
    p12: 'No mint records yet',
    p13: 'Total Reward',
    p14: 'Referral Reward',
    p15: 'Address Count',
    p16: 'addresses',
    p17: 'Reward Amount',
    p18: 'Reward History',
    p19: 'No rewards yet',
    p20: 'Time',
    p21: 'Invited Address',
    p22: 'Referral Reward',
    p23: 'Loading',
    p24: 'No More',
    p25: 'Invite Friends',
    p26: 'Please connect your wallet first',
    p27: 'After connecting your wallet, you can view your minting records and reward details',
    p28: 'Connect wallet',
  },
  share: {
    p1: 'Referral Program',
    p2: 'Invite Friends,',
    p3: 'Share Rewards',
    p4: 'Share your exclusive referral link. Earn generous commission rewards for every successful referral purchase.',
    p5: 'Direct Referral',
    p6: 'When your direct referral makes a purchase',
    p7: 'Commission Rate',
    p8: 'Earn per unit',
    p9: 'Indirect Referral',
    p10: `When your referral's referral makes a purchase`,
    p11: 'Commission Rate',
    p12: 'Earn per unit',
    p13: 'Commission Distribution Example',
    p14: 'Scenario',
    p15: 'Direct Commission',
    p16: 'Indirect Commission',
    p17: 'Direct Only',
    p18: 'A refers B to purchase',
    p19: 'Direct + Indirect',
    p20: 'A refers B, B refers C to purchase',
    p21: 'Get Your Exclusive Referral Link',
    p22: `Share this link with friends. You'll earn commission when they purchase through your link.`,
    p23: 'Connect wallet',
    p24: 'Instant Payout',
    p25: 'Commission auto-distributed to your wallet',
    p26: 'Unlimited Referrals',
    p27: 'No limit on referral count',
    p28: 'Permanent Binding',
    p29: 'Referral relationship recorded on-chain forever',
  },
  fq: {
    p1: 'RAQ',
    p2: 'Frequently Asked',
    p3: 'Questions',
    p4: 'If you have other questions, feel free to contact us through official channels',
  },
  foot: {
    p1: 'Web3 consulting, education & community platform NFT based on BSC blockchain. Collect city co-builder digital identity certificates, build Web3 talent infrastructure ecosystem.',
    p1_1: 'Resources',
    p2: 'Smart Contract',
    p3: 'Community',
    p4: 'Legal',
    p5: 'Terms of Service',
    p6: 'Privacy Policy',
    p7: 'Disclaimer',
  }
}